module.exports = __webpack_public_path__ + "static/img/agentgrid-panel.2c4357ed.jpg";